import React from "react";
import Spinner from '@paljs/ui/Spinner';
import styled from "styled-components";

const LoadContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

const LoadingCard = ({ isLoading, children }) => {
  return (
    <>
      {isLoading ? (
        <LoadContainer>
          <Spinner status="Primary" style={{ backgroundColor: '#ffffff55' }}/>
        </LoadContainer>
      ) : !!children ? (
        children
      ) : (
        <div />
      )}
    </>
  );
};

export { LoadingCard };
